import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";
import { formatApiError } from "@/lib/api";

export const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { completeGoogle, bootstrap } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    completeGoogle(sessionId)
      .then(() => {
        toast.success("Signed in with Google");
        navigate("/", { replace: true });
      })
      .catch(async (e) => {
        toast.error(formatApiError(e));
        await bootstrap();
        navigate("/login", { replace: true });
      });
  }, [location.hash, completeGoogle, bootstrap, navigate]);

  return null;
};
